import {SelectItem} from '../shared/components/select-menu/select-menu.component';

export function objectArrayToSelectOptions<T>(
    items: T[],
    valueKey: keyof T,
    labelKey: keyof T
  ): SelectItem[] {
    return items.map(item => ({
      key: String(item[valueKey]),
      label: String(item[labelKey])
    }));
}

export function stringArrayToSelectOptions(items: string[]): SelectItem[] {
  return items.map(item => ({
    key: item,
    label: item
  }));
}
